'use strict';
const mmWidgets = require('./mm-widgets');
mmWidgets.fn.addMeasureWidget = function (measuresModel) {
	return mmWidgets.each(this, function () {
		const ENTER = 13,
			element = this,
			measureNameInput = element.find('[data-mm-role~="measure-name"]'),
			addMeasureButton = element.find('[data-mm-role~="add-measure"]'),
			addMeasureAction = function () {
				const measureName = measureNameInput.val();
				if (measureName && measuresModel.addMeasure(measureName)) {
					element.addClass('hidden');
				} else {
					measureNameInput.parents('div.control-block').addClass('error');
					measureNameInput.focus();
				}
			};


		element.on('show', function () {
			measureNameInput.val('');
			measureNameInput.parents('div.control-block').removeClass('error');
			measureNameInput.focus();
		});
		measureNameInput.on('keyup', function (e) {
			if (e.keyCode === ENTER) {
				addMeasureAction();
			}
		});
		addMeasureButton.click(addMeasureAction);
	});
};
